<template>
  <div class="d-flex justify-content-between flex-wrap">
    <div class="d-flex align-items-center mb-0 mt-1">
      <span class="text-nowrap ml-1">
        {{ $t('message.pagelength') }}
      </span>
      <b-form-select
        v-model="pageData.pageSize"
        :options="pageOptions"
        class="mx-1"
        @input="pageSizeChange(props, $event)"
      />
      <span class="text-nowrap">
        {{ $t('message.of') }}
        <span class="mr-1 ml-1" style="font-size:20px;">{{
          pageData.total
        }}</span>
        {{ $t('message.pageText2') }}
      </span>
    </div>
    <div>
      <b-pagination
        :value="pageData.currentPage"
        :total-rows="pageData.total"
        :per-page="pageData.pageSize"
        first-number
        last-number
        align="right"
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0 mr-1"
        @input="pageChange(props, $event)"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import { BPagination, BFormSelect } from 'bootstrap-vue'

export default {
  name: 'CPagination',
  components: {
    BPagination,
    BFormSelect,
  },
  props: {
    props: {
      type: Object,
      default: () => ({}),
    },
    pageOptions: {
      type: Array,
      default: () => ['10', '20', '30', '50', '100'],
    },
    // 分页
    /**
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
    */
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    pageData() {
      return {
        pageSize: this.page.pageSize || 10,
        currentPage: this.page.currentPage || 1,
        total: this.page.total || 0,
      }
    },
  },
  mounted() {
    this.firstPageSizeChange(this.props)
  },
  methods: {
    firstPageSizeChange(props, value) {
      props.perPageChanged({ currentPerPage: this.page.pageSize })
    },
    pageChange(props, value) {
      props.pageChanged({ currentPage: value })
      this.$emit('pageChange', value)
    },
    pageSizeChange(props, value) {
      props.perPageChanged({ currentPerPage: value })
      this.$emit('pageSizeChange', value)
    },
  },
}
</script>

<style lang="scss" scoped></style>
